import { PRODUCTION, DEVELOPMENT, LOCAL_PAYMENTS_URL } from "./const";
import { isEmpty } from "lodash";

export function getPaymentsUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const PAYMENTS_URL = !!process.env.REACT_APP_PAYMENTS_URL && process.env.REACT_APP_PAYMENTS_URL !== "" ? process.env.REACT_APP_PAYMENTS_URL : LOCAL_PAYMENTS_URL;
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return PAYMENTS_URL;
      case PRODUCTION:
        return PAYMENTS_URL;
      default:
        return PAYMENTS_URL;
    }
  } else {
    return LOCAL_PAYMENTS_URL;
  }
}

export const getPaymentsUrlValue = () => {
  return getPaymentsUrl();
};
